'use strict';

function Infrastructure (object, dictionary) {
  /** @var Parking|null Тип парковки */
  this.parking = dictionary.getParking(object.get('parkingTypeId')) || null;

  /** @var bool|null Наличие охраняемой парковки */
  this.protectedParking = object.get('hasProtectedParking', null);

  /** @var bool|null Наличие бани */
  this.bathhouse = object.get('hasBathhouse', null);

  /** @var bool|null Наличие гаража */
  this.garage = object.get('hasGarage', null);

  /** @var bool|null Наличие хоз построек */
  this.outbuildings = object.get('hasOutbuildings', null);

  /** @var bool|null Наличие охраны */
  this.securityProtection = object.get('hasSecurityProtection', null);
}

Infrastructure.prototype.hasBathhouse = function () {
  return this.bathhouse;
};

Infrastructure.prototype.hasGarage = function () {
  return this.garage;
};

Infrastructure.prototype.hasOutbuildings = function () {
  return this.outbuildings;
};

Infrastructure.prototype.getParking = function () {
  return this.parking;
};

Infrastructure.prototype.hasProtectedParking = function () {
  return this.protectedParking;
};
Infrastructure.prototype.getLabelProtectedParking = function () {
  return this.hasProtectedParking() ? 'парк./охр.' : '';
};

Infrastructure.prototype.hasSecurityProtection = function () {
  return this.securityProtection;
};
Infrastructure.prototype.getLabelSecurityProtection = function () {
  return this.hasSecurityProtection() ? 'охрана' : '';
};

export default Infrastructure;



// WEBPACK FOOTER //
// ./src/classes/announcement/property/infrastructure.js